// extracted by mini-css-extract-plugin
module.exports = {"BundlesDetailsAccordianUI":"BundleDetailsAccordianUI_BundlesDetailsAccordianUI__2ME_l","accordianContainer":"BundleDetailsAccordianUI_accordianContainer__GN3D0"};